import Axios from "axios";
import { SET_INV_ITEMS_REPORT, UNSET_INV_ITEMS_REPORT } from "@/store/mutation-types";
import { getInvItemsReport } from "@/store/api";

const state = { getInvItemsReport: {} };

const getters = {
  getInvItemsReport(state) {
    return state.getInvItemsReport;
  },
};

const mutations = {
  [SET_INV_ITEMS_REPORT](state, data) {
    state.getInvItemsReport = data;
  },
  [UNSET_INV_ITEMS_REPORT](state) {
    state.getInvItemsReport = {};
  },
};

const actions = {
  getInvItemsReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvItemsReport, { params: data })
        .then(function (response) {
          commit("SET_INV_ITEMS_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_ITEMS_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
